module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-14.eaff331e.png";